module.exports = __webpack_public_path__ + "img/ereszkalkulator_25_bilics_merete_rovid_fekete.8c217f1b.png";